// src/components/modalForm/ModalSearchBar.js
import React from 'react';
import { FiSearch, FiX } from 'react-icons/fi';
import Input from '../input/Input';

const ModalSearchBar = ({ value, onChange, label = 'Pesquisar', placeholder = 'Digite para pesquisar...', className = '', inputRef, autoFocus = true, size = '100%', ...props }) => (
  <div className={`modal-search-bar ${className}`.trim()} style={{ width: size, maxWidth: '100%' }}>
    <FiSearch className="modal-search-icon" aria-hidden="true" />
    <Input {...props} label={label} value={value} onChange={onChange} placeholder={placeholder} inputRef={inputRef} autoFocus={autoFocus} size="100%" />
    {value && <button type="button" className="modal-search-clear" aria-label="Limpar pesquisa" onClick={() => onChange?.({ target: { value: '' } })}><FiX aria-hidden="true" /></button>}
  </div>
);

export default ModalSearchBar;
